<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Subject Infected Details
      </h2>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col cols="6">
        </b-col>
        <b-col cols="3">
          <b-form-select
            size="lg"
            v-model="category"
            :options="categoryOptions"
          ></b-form-select>
        </b-col>
        <b-col cols="auto">
          <h2>
            <b-badge>
              {{options.totalRows}}
            </b-badge>
          </h2>
        </b-col>
        <b-col cols="auto">
          <b-button size="lg" @click="download()">
            Download
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <br>

    <!-- loading alert -->
    <b-alert v-if="dataLoading" variant="info" show>Loading...<i class="fas fa-spin fa-spinner"></i></b-alert>

    <b-table
      ref="table"
      striped
      hover
      responsive
      :items="data"
      :fields="fields"
      :busy.sync="loading"
      :current-page="options.currentPage"
      :per-page="options.perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
        <template v-slot:cell(subject_age)="data">
            {{roundAge(data.value)}}
        </template>
    </b-table>

    <b-pagination
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from 'lodash';

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 0,
        perPage: 20
      },
      loading: false,
      // pull down menu
      category: 'all',
      categoryOptions: [
        {value: 'all', text: 'All'},
        {value: 'eleven_days', text: '11 Day Wait'},
        {value: 'fourteen_days', text: '14 Day Wait'},
      ],
      search: "",
      fields: [],
      data: [],
      sortBy: "id",
      sortDesc: false,
      title: "",
      totalItems: 0,
      stacked: false,
      dataLoading: false
    };
  },
  // watch category for pull down menu
  watch: {
    category: function() {
      this.find();
    },
  },
  created() {
    this.find();
  },
  methods: {
    find() {
      const that = this;

      that.dataLoading = true

      HTTP.get("/eavetubes/metrics/subject-infected-details", {
        params: {
          category: that.category,
        }
      })
        .then(response => {

          let fields = [];
          _.each(response.data.fields, function(field) {
            fields.push({
              key: field,
              sortable: true
            });
          });
          that.fields = fields;

          that.data = response.data.data;
          that.options.totalRows = parseInt(response.data.total);

          that.dataLoading = false

        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
          that.dataLoading = false
        });
    },
    download() {
      const that = this;

      let csv = '';
      let fields = _.values(_.mapValues(that.fields, 'key'));

      csv += fields.join(',') + '\n';

      _.each(that.data, function(item) {
        let row = [];
        _.each(fields, function(field) {
          row.push(item[field]);
        });
        csv += row.join(',') + '\n';
      });

      let hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      // change filename
      const additional_fiilename = that.category == 'all'
        ? 'No-Wait'
        : that.category == 'eleven_days'
          ? 'Wait-11-days'
          : 'Wait-14-days'
      hiddenElement.download = `ET_Subject-Infected-Details-${additional_fiilename}-${new Date().toLocaleDateString('en-CA')}.csv`;
      hiddenElement.click();
    },
    roundAge(age) {
      let num = parseFloat(age);
      return _.isNaN(num) ? 0.0 : _.floor(num, 1);
    }
  }
};
</script>

<style></style>
